import {
  LocationSearch,
  MIN_LOCATION_SEARCH_LENGTH,
  useLocationSearch as _useLocationSearch,
} from '@griply/hooks';
import { useTranslation } from 'react-i18next';
import { useLocationSuggestionsQuery } from 'shared/hooks/queries/use-location-suggestions-query';
import { getLocationDetails } from 'shared/services/backend-api';
import { v4 as uuidv4 } from 'uuid';

export { MIN_LOCATION_SEARCH_LENGTH };

export const useLocationSearch = (): LocationSearch => {
  const { i18n } = useTranslation();
  const { suggestions, isFetching, fetchSuggestions } =
    useLocationSuggestionsQuery();

  return _useLocationSearch({
    suggestions,
    isFetching,
    fetchSuggestions,
    getLocationDetails,
    languageCode: i18n.language,
    createSessionToken: uuidv4,
  });
};
